<template>
  <button class="clear-filter-button" @click="$emit('click')">Очистить все</button>
</template>
<script>
export default {
  name: 'ClearFilterButton',
};
</script>
